/// <amd-module name="VSS/Diagnostics/UI/Components/Segment/Segment" />
import * as React from "react";

import { PerfSectionDataSegment } from "VSS/Diagnostics/PerfBar";
import { ITooltipProps, Tooltip } from "VSSUI/TooltipEx";
import { css } from "VSSUI/Util";

export interface ISegmentProps {
    className?: string;
    dataSegment: PerfSectionDataSegment;
    onClick?: () => void;
    tooltipProps?: ITooltipProps;
}

export class Segment extends React.Component<ISegmentProps> {
    public render(): JSX.Element {
        const tooltipProps: ITooltipProps = this.props.tooltipProps || { text: this.props.dataSegment.segmentTooltip };

        return (
            <Tooltip {...tooltipProps}>
                <span
                    className={css("perf-segment-data flex-row flex-center", this.props.className, this.props.onClick && "actionable")}
                    onClick={this.props.onClick}
                >
                    <span className="perf-segment-label">{this.props.dataSegment.segmentLabel}</span>
                    <span className="perf-segment-content">{this.props.dataSegment.segmentContent}</span>
                </span>
            </Tooltip>
        );
    }
}
